module.exports = __webpack_public_path__ + "static/media/sorrento-7.87a63a6c.jpg";